/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavForChannelCell = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _transition = require("../utils/transition");
var _ChannelCell = _interopRequireDefault(require("./ChannelCell"));
var _channelColumn = _interopRequireDefault(require("./channelColumn.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultComponents = {
  ChannelCell: _ChannelCell["default"]
};
var getNavForChannelCell = function getNavForChannelCell(channelIndex, channels, onMoveTo, onUp, onDown, onLeft, onRight, changeFocus) {
  var columnNav = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : {};
  var channel = channels[channelIndex];
  var previousChannel = channels[channelIndex - 1] || {};
  var nextChannel = channels[channelIndex + 1] || {};
  var parentNav = columnNav || {};
  return _objectSpread(_objectSpread({}, parentNav), {}, {
    id: "".concat(channel.channelId),
    internal: _objectSpread(_objectSpread({}, parentNav.internal || {}), {}, {
      nextleft: function nextleft() {
        if (!previousChannel.channelId) {
          if (parentNav && parentNav.nextleft) {
            changeFocus && changeFocus(parentNav.nextleft);
          } else if (parentNav && parentNav.internal && parentNav.internal.nextleft) {
            parentNav.internal.nextleft();
          } else {
            return false;
          }
          return true;
        }
        changeFocus && changeFocus(previousChannel.channelId);
        onLeft && onLeft();
        return true;
      },
      nextright: function nextright() {
        if (!nextChannel.channelId) {
          if (parentNav && parentNav.nextright) {
            changeFocus && changeFocus(parentNav.nextright);
          } else if (parentNav && parentNav.internal && parentNav.internal.nextright) {
            parentNav.internal.nextright();
          } else {
            return false;
          }
          return true;
        }
        changeFocus && changeFocus(nextChannel.channelId);
        onRight && onRight();
        return true;
      }
    })
  });
};
exports.getNavForChannelCell = getNavForChannelCell;
var roundOffset = function roundOffset(offset) {
  return Math.round(offset * 10) / 10;
};

/**
 * A column of channel cells to display next to the
 * program guide grid data.
 * A channel cell would typically display the channels
 * name or logo and possibly enable clicks.
 * The column is scrollable by setting the top offset position.
 *
 * @param {object} props  See prop types.
 * @returns {node} The component
 */
var ChannelColumn = function ChannelColumn(props) {
  var animation = props.animation,
    changeFocus = props.changeFocus,
    channelDisplayCount = props.channelDisplayCount,
    channels = props.channels,
    components = props.components,
    componentsProps = props.componentsProps,
    height = props.height,
    horizontal = props.horizontal,
    nav = props.nav,
    offset = props.offset,
    onClickChannel = props.onClickChannel,
    onDown = props.onDown,
    onGetNavForChannelCell = props.onGetNavForChannelCell,
    onLeft = props.onLeft,
    onMoveTo = props.onMoveTo,
    onRight = props.onRight,
    onUp = props.onUp,
    style = props.style,
    theme = props.theme,
    width = props.width;
  var _defaultComponents$co = _objectSpread(_objectSpread({}, defaultComponents), components),
    ChannelCell = _defaultComponents$co.ChannelCell;
  var channelOffsetSize = (0, _react.useMemo)(function () {
    return 1 / channelDisplayCount;
  }, [channelDisplayCount]);
  var roundedOffset = roundOffset(offset);
  var initialChannelIndex = roundedOffset / channelOffsetSize;
  var rowWidth = horizontal ? width / channelDisplayCount : width;
  var rowHeight = horizontal ? height : height / channelDisplayCount;
  var _style = _objectSpread({
    width: width,
    height: height
  }, style);
  var translate = horizontal ? -offset * width : -offset * height;
  var transform = horizontal ? "translateX(".concat(translate, "px)") : "translateY(".concat(translate, "px)");
  var innerContainerStyle = translate !== 0 ? {
    transform: transform,
    WebkitTransform: transform,
    transition: (0, _transition.animationToTransition)(animation)
  } : null;
  var className = (0, _classnames["default"])(theme.channelColumn, _defineProperty({}, theme.horizontal, horizontal));
  var channelCellProps = componentsProps.ChannelCell || {};
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className,
    style: _style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.innerContainer,
    style: innerContainerStyle
  }, channels.map(function (channel, localChannelIndex) {
    if (localChannelIndex < initialChannelIndex || localChannelIndex >= initialChannelIndex + channelDisplayCount) {
      return null;
    }
    var __channelIndex = channel.__channelIndex;
    var channelNav = onGetNavForChannelCell(localChannelIndex, channels, onMoveTo, onUp, onDown, onLeft, onRight, changeFocus, nav);
    var cellTransform = horizontal ? "translateX(".concat(rowWidth * __channelIndex, "px)") : "translateY(".concat(rowHeight * __channelIndex, "px)");
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: channel.channelId,
      style: {
        position: 'absolute',
        transform: cellTransform,
        WebkitTransform: cellTransform
      }
    }, /*#__PURE__*/_react["default"].createElement(ChannelCell, _extends({
      key: channel.channelId,
      channel: channel,
      channelIndex: __channelIndex,
      height: rowHeight,
      horizontal: horizontal,
      nav: channelNav,
      onClick: function onClick() {
        return onClickChannel && onClickChannel(channel);
      },
      width: rowWidth
    }, channelCellProps)));
  })));
};
ChannelColumn.propTypes = {
  /**
   * Animation settings deciding ```enabled```,
   * ```speed``` and ```type``` (e.g. linear, ease-out)
   */
  animation: _propTypes["default"].shape({
    disabled: _propTypes["default"].bool,
    speed: _propTypes["default"].number,
    type: _propTypes["default"].string
  }),
  /** Function to update the navigation focus */
  changeFocus: _propTypes["default"].func,
  /** How many channels to display in view */
  channelDisplayCount: _propTypes["default"].number,
  /** List of channel objects to represent column cells */
  channels: _propTypes["default"].array,
  /** Overridable inner components */
  components: _propTypes["default"].shape({
    ChannelCell: _propTypes["default"].func
  }),
  /** Extra props passed to the components */
  componentsProps: _propTypes["default"].shape({
    ChannelCell: _propTypes["default"].object
  }),
  /** Visible height of the column */
  height: _propTypes["default"].number,
  /** If the channel cells are to be layed out horizontally */
  horizontal: _propTypes["default"].bool,
  /** The @accedo/vdkweb-navigation nav object */
  nav: _propTypes["default"].object,
  /** Offset top position, for scrolling the column */
  offset: _propTypes["default"].number,
  /** Click handler for a channel cell */
  onClickChannel: _propTypes["default"].func,
  /** Function to handle the EPG down movement */
  onDown: _propTypes["default"].func,
  /** Function to retrieve the nav object */
  onGetNavForChannelCell: _propTypes["default"].func,
  /** Function to handle the EPG left movement */
  onLeft: _propTypes["default"].func,
  /** Function to handle the EPG movement */
  onMoveTo: _propTypes["default"].func,
  /** Function to handle the EPG right movement */
  onRight: _propTypes["default"].func,
  /** Function to handle the EPG up movement */
  onUp: _propTypes["default"].func,
  /** Styles to be applied to the outer container div */
  style: _propTypes["default"].object,
  /** Classname API for theming */
  theme: _propTypes["default"].shape({
    channelColumn: _propTypes["default"].string,
    horizontal: _propTypes["default"].string,
    innerContainer: _propTypes["default"].string
  }),
  /** Width of the column */
  width: _propTypes["default"].number
};
ChannelColumn.defaultProps = {
  animation: {},
  channelDisplayCount: 1,
  channels: [],
  componentsProps: {},
  height: 0,
  horizontal: false,
  nav: {},
  offset: 0,
  onGetNavForChannelCell: getNavForChannelCell,
  style: {},
  theme: _channelColumn["default"],
  width: 0
};
var _default = /*#__PURE__*/_react["default"].memo(ChannelColumn);
exports["default"] = _default;